<template>
	
  <PageComponents>
    <template>
    <div>

      <div class="container">
        <div class="row voffset-lg mt-lg-0 mb-lg-5">
          <div class="col-lg-6">
            <h3 class="text-center text-lg-start tc-4241 h3-2-style h3-bloc-1-style mb-lg-3">Software Customization
              Services</h3>
            <p class="p-8-style mb-lg-1 tc-2340 text-lg-start">We provide development services including software design
              and system design for enterprises, and deliver projects by quality within the budget. And we are able to
              provide technical advice to help clients determine their specific requirements for the corresponding
              software or product, and manage and maintain it throughout its lifecycle.<br></p>
            <div class="row">
              <div class="col">
                <div class="text-center mt-lg-4 text-lg-start"><span
                    class="icon-4241 mb-lg-2 icon-md fa fa-people-arrows"></span></div>
                <h5 class="mb-4 tc-4241 text-lg-start mb-lg-1 h5-bloc-8-style">Technical Consultation</h5>
                <p class="tc-2340 p-style mb-lg-0 text-lg-start">Provide technical consulting on product software,
                  product system, etc.</p>
              </div>
              <div class="col">
                <div class="text-center mt-lg-4 text-lg-start"><span
                    class="icon-md icon-4241 mb-lg-2 float-lg-none far fa-window-restore"></span></div>
                <h5 class="mb-4 tc-4241 text-lg-start mb-lg-1 h5-2-style">Software Design and Development</h5>
                <p class="tc-2340 p-style mb-lg-0">Provide software maintenance and function improvement support</p>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="text-center mt-lg-4 text-lg-start"><span
                    class="icon-4241 mb-lg-2 icon-md far fa-object-group"></span></div>
                <h5 class="mb-4 tc-4241 text-lg-start mb-lg-1 h5-3-style">System Design and Development</h5>
                <p class="tc-2340 p-style">Provide system maintenance and function improvement support</p>
              </div>
              <div class="col">
                <div class="text-center mt-lg-4 text-lg-start"><span
                    class="icon-md icon-4241 mb-lg-2 float-lg-none fab fa-deezer"></span></div>
                <h5 class="mb-4 tc-4241 text-lg-start mb-lg-1 h5-4-style">Program Replication Data Recovery</h5>
                <p class="tc-2340 p-style">Provide software/system and data recovery service</p>
              </div>
            </div>
            <div class="row g-0 mt-lg-5">
              <div class="col-sm-8">
                <h3 class="text-lg-start float-lg-none mb-lg-2 h3-联系方式-style tc-4241"><span
                    class="far fa-laugh-wink"></span>&nbsp;Contact Information</h3>
                <p class="p-6-style tc-5727 ms-lg-4 mb-lg-0">Customer Service: 400-777-8776</p>
                <p class="p-6-style tc-5727 ms-lg-4">Email: support@xhorse.com</p>
              </div>
            </div>
          </div>
          <div class="col offset-lg-0 mt-lg-5 pe-lg-0">
            <picture>
              <img :src="png" width="530" height="340" />
            </picture>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h1 class="mb-4">&nbsp;</h1>
          </div>
        </div>
      </div>
    </div>
    </template>
  </PageComponents>
</template>

<script>
import PageComponents from "@/components/page-components-mobile";
import png from "@/assets/css/img/wangye.png";
export default {
  components: {
    PageComponents
  },
  data: () => ({
    png,
    activeIndex: {
      side: [],
      top: []
    }
  })
};
</script>
<style scope>
@import "../../../../assets/css/all/all.min.css";
@import "../../../../assets/css/all/animate.min.css";
@import "../../../../assets/css/all/style.css";
@import "../../../../assets/css/all/bootstrap.min.css";
.container {
  text-align: left;
  margin-top: 100px;
  margin-bottom: 100px;
}
</style>





// WEBPACK FOOTER //
// src/components/mobile/zh-cn/software/index.vue